import {usePathname} from '@aboutyou/router';

export const useCouponPath = () => {
  const pathname = usePathname();
  return (categoryId?: number): string => {
    if (!categoryId) {
      return pathname;
    }

    return `${pathname}?category=${categoryId}`;
  };
};
